export const getTotalPriceDiscountByArticle = (quantity, price, discount) => {
  const total_price = quantity * price;
  const total = total_price - total_price * (discount / 100)
  return total > 0 ? total.toFixed(2) : 0;
};

const getPrice = (articles) => {
  let total = 0;
  articles.forEach(element => {
    total += element.total_price;
  });
  return parseFloat(total);
};

export const getTotalOrder = (articles, discount, shippingCost) => {
  const total = getPrice(articles);
  if (shippingCost) {
    return parseFloat((total - total * (discount / 100)) + shippingCost).toFixed(2);
  } else {
    return parseFloat(total - total * (discount / 100)).toFixed(2);
  }
};

export const getSubTotalOrder = (articles, discount) => {
  const total = getPrice(articles);
  return parseFloat(total - total * (discount / 100)).toFixed(2);
};

export const getMinYear = (data) => {
  return data.reduce((min_year, item) => {
    const year = new Date(item.fecha).getFullYear();
    return year < min_year ? year : min_year;
  }, new Date(data[0].fecha).getFullYear());
};
